//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CouponCard from '@/components/CouponCard';
import XInput from 'vux/src/components/x-input';
import XButton from 'vux/src/components/x-button';
import XDialog from 'vux/src/components/x-dialog';
import { sendCode } from '@/api/login';
import UBT from '@/utils/ubt';
import Storage from '@/utils/storage';
import bannerImg from '@/assets/images/banner.png';

const mobileTest = /^1[0-9]{10}$/;

const smsTest = /^[0-9]{4}$/;

export default {
  components: {
    CouponCard,
    XInput,
    XButton,
    XDialog
  },
  data() {
    return {
      inputVal: '',
      imageKaptcha: '',
      visable: false,
      form: {
        mobile: '',
        smsCode: '',
      },
      releaseTime: 0,
      hasSend: false,
      bannerImg,
    };
  },

  computed: {
    disabled() {
      return !this.validMobilePase || !this.validSmsCodePase;
    },
    inputVals() {
      return (this.inputVal || '').split('') || [];
    },
    canSend() {
      return this.releaseTime <= 0;
    },
    validMobilePase() {
      return mobileTest.test(this.form.mobile || '');
    },
    validSmsCodePase() {
      return smsTest.test(this.form.smsCode || '');
    }
  },

  mounted() {
    UBT.pageView({
      pageId: 'H5_换电_租车方登录页',
    });
    this.init();
  },

  methods: {
    init() {
      this.initResaseTime();
    },
    onBlur() {
      window.scrollTo(0, 0);
    },
    initResaseTime() {
      const lastSendTime = Storage.getItem('last-send-time') || 0;
      const now = Date.now();
      const releaseTimeMs = 60000 - (now - lastSendTime);
      const releaseTime = releaseTimeMs < 0
        ? 0
        : parseInt((releaseTimeMs) / 1000, 10);
      this.releaseTimeTask(releaseTime);
    },
    async login() {
      const {
        form: { mobile: mobilePhone, smsCode } = {}
      } = this;
      try {
        if (!mobileTest.test(mobilePhone)) {
          throw new Error('请输入正确手机号');
        }
        await this.$store.dispatch('login', {
          mobilePhone,
          smsCode,
          roleType: 3,
        });
        this.$router.replace({
          name: 'rentList',
          query: {
          }
        });
      } catch (e) {
        this.$throw(e);
      }
    },
    async getImageCaptcha() {
      if (!this.validMobilePase) {
        return;
      }
      try {
        const res = await sendCode({
          mobile: this.form.mobile,
        });
        if (res.ok) {
          this.hasSend = true;
          this.$vux.toast.show({
            type: 'text',
            width: 'auto',
            text: '发送成功',
          });
          this.releaseTimeTask(60);
          Storage.setItem('last-send-time', Date.now());
        } else if (+res.imageStatus === 1) {
          this.imageKaptcha = res.imageCaptcha;
          window.scrollTo(0, 0);
          this.visable = true;
          this.inputVal = '';
        } else {
          throw new Error('发生未知错误');
        }
      } catch (e) {
        this.$throw(e);
      }
    },
    async handelInput() {
      if (this.inputVal.length >= 4) {
        try {
          const res = await sendCode({
            mobile: this.form.mobile,
            capText: this.inputVal,
          });
          if (res.ok) {
            this.hasSend = true;
            this.visable = false;
            this.$vux.toast.show({
              type: 'text',
              width: 'auto',
              text: '发送成功',
            });
            this.releaseTimeTask(60);
            Storage.setItem('last-send-time', Date.now());
          } else if (+res.imageStatus === 2) {
            this.imageKaptcha = res.imageCaptcha;
            this.inputVal = '';
            throw new Error('图片验证码输入错误');
          } else {
            throw new Error('发生未知错误');
          }
        } catch (e) {
          this.$throw(e);
        }
      }
    },
    releaseTimeTask(releaseTime) {
      this.releaseTime = releaseTime;
      if (releaseTime > 0) {
        setTimeout(() => {
          this.releaseTimeTask(releaseTime - 1);
        }, 1000);
      } else {
        Storage.removeItem('last-send-time');
      }
    }
  }
};
